import { Card, CardContent, CardHeader, Grid } from '@mui/material';
import { useMemo, useState } from 'react';
import { formatThoundsandNumber, stableHash, stableHashUnit } from '../../../../abelcommon';
import AnalyticsRoundedIcon from '@mui/icons-material/AnalyticsRounded';
import './poolStyle.css';
import { SinglePoolSummaryInfo } from '../../../../api/load-balancer';
import { HashRateChartDialog } from './HashRateDialog';
import { GPUCardsOnlinesDialog } from './GPUCardsOnlineDialog';
import { GPUClientsOnlinesDialog } from './GPUClientsOnlineDialog';

export const PoolSummary = ({ poolInfo }: { poolInfo: SinglePoolSummaryInfo }) => {
  const [openModal, setOpenModal] = useState<string | null>(null);
  const [selectedPool, setSelectedPool] = useState<SinglePoolSummaryInfo | null>(null);

  const handleClickOpen = (pool: SinglePoolSummaryInfo, modalType: string) => {
    setSelectedPool(pool);
    setOpenModal(modalType);
  };

  const handleClose = () => {
    setSelectedPool(null);
    setOpenModal(null);
  };

  const summaryInfo = useMemo(() => {
    const propsPlaceholder = [
      { key: 'Hash Rate', value: '', icon: '', pool: null as SinglePoolSummaryInfo | null, modalType: 'hashRate' },
      {
        key: 'Mining Rigs Online',
        value: '',
        icon: '',
        pool: null as SinglePoolSummaryInfo | null,
        modalType: 'gpuClients',
      },
      {
        key: 'GPU Cards Online',
        value: '',
        icon: '',
        pool: null as SinglePoolSummaryInfo | null,
        modalType: 'gpuCards',
      },
    ];

    return !poolInfo
      ? propsPlaceholder
      : [
          {
            key: 'Hash Rate',
            value: `${formatThoundsandNumber(stableHash(poolInfo.hashRate * 1000), 4)} ${stableHashUnit(poolInfo.hashRate * 1000)}/s`,
            icon: <AnalyticsRoundedIcon style={{ fontSize: '30px' }} />,
            pool: poolInfo,
            modalType: 'hashRate',
          },
          {
            key: 'Mining Rigs Online',
            value: formatThoundsandNumber(poolInfo.machineCount),
            icon: <AnalyticsRoundedIcon style={{ fontSize: '30px' }} />,
            pool: poolInfo,
            modalType: 'gpuClients',
          },
          {
            key: 'GPU Cards Online',
            value: formatThoundsandNumber(poolInfo.cardCount),
            icon: <AnalyticsRoundedIcon style={{ fontSize: '30px' }} />,
            pool: poolInfo,
            modalType: 'gpuCards',
          },
        ];
  }, [poolInfo]);

  return (
    <Card>
      <CardHeader title={`Pool ${poolInfo.name}`} />
      <CardContent sx={{ overflow: 'auto' }}>
        <Grid container spacing={1}>
          {summaryInfo.map(({ key, value, icon, pool, modalType }) => (
            <Grid item xs={6} sm={4} md={4} lg={3} xl={3} key={key}>
              <InfoBox
                subtitle=""
                icon={icon}
                title={value}
                content={key}
                onClick={() => pool && modalType && handleClickOpen(pool, modalType)}
              />
            </Grid>
          ))}
        </Grid>
      </CardContent>
      {selectedPool && openModal === 'hashRate' && (
        <HashRateChartDialog open={openModal === 'hashRate'} onClose={handleClose} poolInfo={selectedPool} />
      )}
      {selectedPool && openModal === 'gpuCards' && (
        <GPUCardsOnlinesDialog open={openModal === 'gpuCards'} onClose={handleClose} poolInfo={selectedPool} />
      )}

      {selectedPool && openModal === 'gpuClients' && (
        <GPUClientsOnlinesDialog open={openModal === 'gpuClients'} onClose={handleClose} poolInfo={selectedPool} />
      )}
    </Card>
  );
};

interface InfoBoxProps {
  title: string;
  content: string;
  icon: React.ReactNode;
  subtitle: string;
  onClick?: () => void;
}

const InfoBox = ({ title, content, subtitle, icon, onClick }: InfoBoxProps) => {
  return (
    <div className="global-item-pool" onClick={onClick}>
      <span className="content-global">{content}</span>
      {subtitle ? (
        <div className="title-icon-subtitle-global">
          <div className="title-icon-global">
            <span>{title}</span>
            <span className="icon" onClick={onClick}>
              {icon}
            </span>
          </div>
          <span style={{ fontSize: 'small', fontWeight: '600' }}>{subtitle}</span>
        </div>
      ) : (
        <div className="title-icon-global">
          <span>{title}</span>
          <span className="icon" onClick={onClick}>
            {icon}
          </span>
        </div>
      )}
    </div>
  );
};
